export class CloseModal {
    constructor(optionalOptions = {}) {
        this._modalCloseButtons = document.querySelectorAll('.modal-custom [data-action=\'close\']');

        if (!this._modalCloseButtons) {
            this.destructor();
            return true;
        }

        this._modalCloseButtons.forEach((button) => {
            button.addEventListener("click", (event) => {
                event.preventDefault()
                button.closest('.modal-custom').classList.remove('modal-opened');
            })
        })
    }

    destructor() {
        this._modalCloseButtons = null;
    }
}

export default new CloseModal();
